/**
 * ESM source for Vite/Rollup (named static imports).
 * The CJS sibling (`webSessionPreserve401.cjs`) is auto-generated from this file —
 * edit HERE and run `npm run sync:jtest-cjs` to regenerate.
 * Jest imports the `.cjs` version.
 */

/**
 * Pure decision: preserve web session on 401 after refresh during deploy cutover.
 *
 * @param {{ status: number, code: string|null, refreshOutcomeKind: string|null|undefined, hasRefreshCredential: boolean }} params
 * @returns {boolean}
 */
export function shouldPreserveWebSessionOn401Decision(params) {
  const { status, code, refreshOutcomeKind, hasRefreshCredential } = params;
  if (status !== 401) return false;
  if (code === 'ACCOUNT_INVALIDATED') return false;
  const refreshable =
    code === 'TOKEN_EXPIRED' || code === 'INVALID_TOKEN' || code === null;
  if (!refreshable) return false;
  if (refreshOutcomeKind !== 'transient' && refreshOutcomeKind !== 'success') {
    return false;
  }
  return hasRefreshCredential;
}
